import BoundingBox from "./boundingBox";
import Point from "./point";
import Location from "./location";
import { Loader } from "@googlemaps/js-api-loader";
import OrderProcessClient from "../webHostClient/orderProcess/orderProcessClient";
import PlaceSearchResponse from "../webHostClient/orderProcess/placeSearchResponse";
import GooglePlaceItem from "../webHostClient/orderProcess/googlePlaceItem";

// Google Places API implementation
export default class GooglePlacesSearchProvider {
    private readonly searchLimit: number = 10;
    private readonly loader: Loader;
    private readonly orderProcessClient = new OrderProcessClient();

    public constructor(searchLimit: number, key: string) {
        this.searchLimit = searchLimit;
        this.loader = new Loader({
            apiKey: key,
            version: "weekly"
        });
    }

    public searchText(query: string, success: (locations: Array<Location>) => void): void {
        this.orderProcessClient.GetPlaceSearchResultsAsync({
            searchQuery: query,
        }).then((response: PlaceSearchResponse) => {
            success(this._responseToLocationArray(response));
        });
    }

    private _responseToLocationArray(response: PlaceSearchResponse): Array<Location> {
        let locations: Array<Location> = [];

        if (response.results.length > 0) {
            response.results.forEach((place: GooglePlaceItem) => {
                let name1: string = place.displayName;
                let name2: string = place.nameLine1;
                let townCity: string = place.townCity;
                let county: string = place.county;
                let point: Point;
                let boundingBox: BoundingBox = null;

                point = new Point(place.pointLat, place.pointLong);
                boundingBox = new BoundingBox(
                    place.longMin,
                    place.latMin,
                    place.longMax,
                    place.latMax,
                );

                // Only use a subset of fields to represent the location to the user.
                // Don't duplicate any parts and don't include blanks
                locations.push(new Location(name1, name2, townCity, county, point, boundingBox));
            });
        }

        return locations;
    }
}